export default __webpack_public_path__ + "static/media/check-mark-svgrepo-com.39fbf864.svg";